import Service from './blocks/Service'
import ServiceList from './blocks/ServiceList'
import ServiceBooking from './blocks/ServiceBooking'

export const dynamicBlocks = {
  service: Service,
  serviceList: ServiceList,
  serviceBooking: ServiceBooking
}
